import React from 'react';
import './School.css';


const School = ({ school, degrees }) => {
  return (
    <p className="school">
      <strong className="school-name">{school}</strong> | {degrees}
    </p>
  )
}

export default School;
